module.exports = __webpack_public_path__ + "img/mg.8785f8d0.svg";